import React from "react";

import { cn } from "@utils/utils";

interface ConnectionLoaderProps {
  className?: string;
  variant?: "default" | "small";
}
const ConnectionLoader: React.FC<ConnectionLoaderProps> = ({
  className,
  variant = "default",
}) => {
  return (
    <div
      className={cn(
        "h-full container flex p-10 justify-center items-center relative",
        className,
      )}
    >
      <div className="animate-pulse relative">
        {Array(3)
          .fill(0)
          .map((_, i) => (
            <div
              key={i}
              style={{
                transform: `rotate(${i * 120}deg)`,
                transformOrigin: "center",
              }}
              className={`${variant == "small" ? "h-6 w-6" : "h-10 w-10"} bg-secondary rounded-full absolute`}
            >
              <div
                className={`w-1 bg-secondary -ms-0.5 ${variant == "small" ? "h-20 translate-x-3 translate-y-8" : "h-40 translate-x-5 translate-y-12"}`}
              ></div>
              <div
                className={`bg-secondary rounded-full absolute translate-y-full ${variant == "small" ? "h-5 w-5 mt-4" : "h-10 w-10 mt-4"}`}
              ></div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ConnectionLoader;
